import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px', lineHeight: '1.6', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px', marginTop: "110px", color: "#cc9051" }}>Privacy Policy</h1>

      <p>
        <strong>TULIKA.com</strong> values your privacy and is committed to protecting your personal information.
        This Privacy Policy explains how we collect, use, disclose, and protect your information.
      </p>

      <h4>Information Collection</h4>
      <ul>
        <li>Visit our website</li>
        <li>Contact us through email, phone, or contact form</li>
        <li>Make a purchase or inquiry</li>
        <li>Sign up for our newsletter or updates</li>
      </ul>

      <h4>Types of Information Collected</h4>
      <ul>
        <li><strong>Personal Information:</strong> name, email, phone number, address</li>
        <li><strong>Transactional Information:</strong> payment details, purchase history</li>
        <li><strong>Technical Information:</strong> IP address, browser type, device information</li>
        <li><strong>Analytics Information:</strong> website usage, page views, referral sources</li>
      </ul>

      <h4>Use of Information</h4>
      <ul>
        <li>Respond to inquiries and provide customer service</li>
        <li>Process transactions and payments</li>
        <li>Improve website functionality and user experience</li>
        <li>Send newsletters, updates, and promotional materials (with consent)</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h4>Disclosure of Information</h4>
      <ul>
        <li>Payment processors and financial institutions</li>
        <li>Shipping and delivery services</li>
        <li>Marketing and analytics service providers</li>
        <li>Law enforcement agencies (as required by law)</li>
      </ul>

      <h4>Data Security</h4>
      <p>We implement reasonable security measures to protect your information, including:</p>
      <ul>
        <li>Encryption</li>
        <li>Secure servers</li>
        <li>Firewalls</li>
        <li>Access controls</li>
      </ul>

      <h4>Data Retention</h4>
      <ul>
        <li>As long as necessary to provide services</li>
        <li>As required by law</li>
        <li>For internal record-keeping purposes</li>
      </ul>

      <h4>Your Rights</h4>
      <ul>
        <li>Access and update your information</li>
        <li>Opt-out of marketing communications</li>
        <li>Request deletion of your information</li>
        <li>File a complaint (contact information below)</li>
      </ul>

      <h4>Cookies and Tracking</h4>
      <ul>
        <li>Enhance user experience</li>
        <li>Track website usage</li>
        <li>Improve marketing efforts</li>
      </ul>

      <h4>Third-Party Links</h4>
      <p>
        Our website may contain links to external websites, which have their own privacy policies.
      </p>

      <h4>Changes to Privacy Policy</h4>
      <p>
        We reserve the right to modify or update this Privacy Policy at any time without notice.
      </p>

      <h4>Contact</h4>
      <p>
        For questions, concerns, or requests regarding this Privacy Policy, please contact:
      </p>
      <p>
        <a href="mailto:tulikartsworks@gmail.com">tulikartsworks@gmail.com</a> or call 
        <a href="tel:+919869261077" style={{ marginLeft: '5px' }}>+91 9869261077</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
